import { NetworkStatus, useMutation, useQuery } from '@apollo/client'

import {
  ConsolePost,
  ConsolePostQuery,
  ConsolePostQueryVariables,
  DeletePost,
  DeletePostMutation,
  DeletePostMutationVariables,
  PostStatus,
  PostType,
  StoryFilter,
} from '@/clients/utoniq-core/schema'
import { makeViewModel } from '@/core/architecture'
import { useCurrentUser } from '@/core/auth'

import { Action, State } from './template'

export const useViewModel = makeViewModel<State, Action>(() => {
  const { user } = useCurrentUser()
  const { data, fetchMore, refetch, networkStatus } = useQuery<
    ConsolePostQuery,
    ConsolePostQueryVariables
  >(ConsolePost, {
    variables: {
      artistId: user?.uid ?? '',
      status: [PostStatus.Scheduled],
      storyFilter: StoryFilter.Include,
      // NOTE: utoniqPaginationのmerge処理に必要なため削除NG
      pageInput: { limit: 10 },
      pageInputById: { limit: 10 },
    },
    notifyOnNetworkStatusChange: true,
  })
  const [deletePost, { loading: loadingDeletePost }] = useMutation<
    DeletePostMutation,
    DeletePostMutationVariables
  >(DeletePost)

  return {
    state: {
      userId: data?.user?.id || '',
      artistId: user?.uid ?? '',
      loadingDeletePost,
      artist: data?.artist ?? null,
      loading:
        networkStatus === NetworkStatus.loading ||
        networkStatus === NetworkStatus.refetch ||
        networkStatus === NetworkStatus.fetchMore,
      hasNextPage: !!data?.artist?.posts?.pageInfo.hasNextPage,
      posts: data?.artist?.posts ?? null,
    },
    actions: {
      async onFilter(resourceType) {
        await refetch({
          artistId: user?.uid ?? '',
          resourceType: resourceType.type as PostType,
          status: [PostStatus.Scheduled],
          resourceTypes: resourceType.types,
          storyFilter: resourceType.storyFilter,
          // NOTE: utoniqPaginationのmerge処理に必要なため削除NG
          pageInput: {
            cursor: null,
            limit: 10,
          },
          pageInputById: {
            cursor: null,
            limit: 10,
          },
        })
      },
      async onFetchMore() {
        await fetchMore({
          variables: {
            artistId: user?.uid ?? '',
            status: [PostStatus.Scheduled],
            // NOTE: utoniqPaginationのmerge処理に必要なため削除NG
            pageInput: {
              cursor: data?.artist?.posts?.pageInfo.endCursor,
              limit: 3,
            },
            pageInputById: {
              cursor: data?.artist?.posts?.pageInfo.endCursor,
              limit: 3,
            },
          },
        })
      },
      async onDeletePost(postId: string) {
        await deletePost({ variables: { postId: postId } })
      },
    },
  }
})
